module.exports = __webpack_public_path__ + "images/7d6968a.png";